var _rect, _rect2, _rect3, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignal3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    width: 4.67504,
    height: 22,
    rx: 2.33752,
    fill: "#8B8B8B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 5.17645,
    width: 4.67504,
    height: 16.8235,
    rx: 2.33752,
    fill: "#1EAC24"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 10.6765,
    width: 4.67504,
    height: 11.3235,
    rx: 2.33752,
    fill: "#1EAC24"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.33752,
    cy: 19.25,
    rx: 2.33752,
    ry: 2.75,
    fill: "#1EAC24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignal3);
export default __webpack_public_path__ + "static/media/signal-3.2eb1cdd4b187385e66ed452fc00b5244.svg";
export { ForwardRef as ReactComponent };